import { TeamMember } from '../classes/classes';
import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class TeamsService {
  // "https://www.linkedin.com/company/clsq" - "https://www.linkedin.com/company/convey-choice/about/", - "https://www.linkedin.com/company/future-climate-info/",
  private cls_gs_phone: string = '+44(0) 1732 753 910'; // or pi
  private cls_rs_number: string = '+44(0) 2034 099 510';
  private cls_rs_eu_number: string = '+356 2778 0908';

  //
  private _mandy_stephens = new TeamMember(
    0, 'Mandy', 'Stephens', 'Mandy.Stephens@clsl.co.uk', 'Managing Director, CLS Group Services',
    this.cls_gs_phone, '../../../assets/members/mandy.png',
    'Since qualifying as a Chartered Management Accountant in 2000, Mandy worked in FMCG, Manufacturing, Communications and Insurance industries before starting at CLS in 2008. Mandy is one of our longest standing team members. As a result of Mandy’s dedication, work ethic and knowledge of both “all things CLS” and service provision to the UK property and insurance markets she was appointed to her current role as MD of CLS Group Services.',
    false, 'Accounts@clsl.co.uk');

  private _stacey_coppack = new TeamMember(
    0, 'Stacey', 'Coppack', 'Stacey.Coppack@clsl.co.uk', 'Associate Director | Head of Compliance, CLS Group Services',
    this.cls_gs_phone, '../../../assets/members/stacey.png',
    'Stacey is CLS’ longest serving employee, with over 11 years’ experience in various roles across the business including customer service, underwriting and management. Currently, as Associate Director – Compliance, Stacey is responsible for ensuring the group meets its regulatory obligations. Her role oversees the development and implementation of policies and procedures that safeguard compliance across the group businesses. She is also responsible for designing the regulatory training plan for all staff, to ensure all employees are up to date with the latest requirements.',
    false, 'compliance@clsl.co.uk');

  private _matt_chappell = new TeamMember(
    0, 'Matt', 'Chappell', 'Matt.Chappell@clsrs.co.uk', 'Senior Underwriter, CLS Risk Solutions UK',
    this.cls_rs_number, '../../../assets/members/matt-c.png',
    'Matt has been in the insurance industry for 17 years, the last nine of which with CLS. He started out underwriting motor trade, motor fleet and commercial combined covers at Royal and Sun Alliance, then also tried his hand at commercial broking; but the enjoyment of underwriting was too strong and he later joined Roy Partington at Hardy Syndicates in Lloyds of London, and in turn Conveyancing Risk Solutions. Matt’s current focus within CLS Risk Solutions is the new structural indemnity account. Matt recently got married and has a delightful two - year daughter who keeps him very busy! When he does find time for himself, he loves sport and is still just about managing to get around a football pitch!',
    false);

  private _phil_jarvis = new TeamMember(
    0, 'Phil', 'Jarvis', 'Phil.Jarvis@clsrs.co.uk', 'Senior Underwriter, CLS Risk Solutions UK',
    this.cls_rs_number, '../../../assets/members/phil.png',
    'Phil works with brokers, lawyers, developers and other stakeholders to provide bespoke insurance solutions for risks identified during the development and/or transaction of real estate, renewable energy and infrastructure projects. Phil is also responsible for providing technical underwriting leadership to the underwriting department. In his spare time, Phil enjoys watching football(particularly West Ham), socialising and discovering inspiring new travel destinations.',
    false);

  private _vicky_sweeney = new TeamMember(
    0, 'Vicky', 'Sweeney', 'Vicky.Sweeney@clsrs.co.uk', 'Lead Underwriter, CLS Risk Solutions UK',
    this.cls_rs_number, '../../../assets/members/vicky.png',
    'Vicky leads the Rights of Light product, working closely with clients to curate bespoke policies designed to address each individual requirement, this will often involve developing innovative and hybrid solutions. Vicky and the team are able to deliver this service by combining their experience and expertise to provide tailored risk solutions. Vicky has a keen eye for design, particularly interiors which she hopes to make use of in her first new home.In her spare time Vicky enjoys shopping, eating out and practices relaxation in yoga classes.',
    false);

  private _michael_turland = new TeamMember(
    0, 'Michael', 'Turland', 'Michael.Turland@clsrs.co.uk', 'Lead Underwriter, CLS Risk Solutions UK',
    this.cls_rs_number, '../../../assets/members/4@2x.png',
    'Michael leads the Legal Indemnity team at CLS RS and specialises in creating bespoke solutions for known risks falling outside of the traditional Legal Indemnity framework - particularly in instances of live litigation and for complex/technical risks. Michael and his team are able to create tailored and unique solutions for a variety of contingent property law risks in the UK.Outside of the office, Michael is a bibliophile who enjoys travelling and running.',
    false);

  private _chantelle_wren = new TeamMember(
    0, 'Chantelle', 'Wren', 'Chantelle.Wren@clspropertyinsight.co.uk', 'Legal Indemnity Manager, CLS Property Insight',
    this.cls_gs_phone, '../../../assets/members/chantelle.png',
    'Chantelle heads the Legal Indemnity underwriting team for CLS Property Insight in our Kent office. The team are renowned for their accuracy, knowledge and dedication to ensuring they understand and meet clients’ needs. Chantelle is the key contact for all of your Legal Indemnity needs, particularly with guidance of our online and offline suite of products. After a busy week at work Chantelle enjoys relaxing in her spare time. This includes meeting up with family, taking her dog on scenic walks, going to the cinema or perhaps most commonly - going for coffee and cake with her friends!',
    false);

  private _william_brooks = new TeamMember(
    0, 'William', 'Brooks', 'Will.Brooks@clsrs.eu', 'Business Development Director, CLS Risk Solutions EU',
    this.cls_rs_eu_number, '../../../assets/members/Will.png',
    'Will\'s main objective is to aide European developers, funds and financiers in managing risks that are identified during the development and/or transaction of real estate, renewable energy and infrastructure projects. He is working to achieve this by meeting stakeholders within the industry, creating new client relationships and working closely with the leading European insurance brokers.	Will enjoys golf, padel, fishing and long distance hiking, and his perfect Sunday morning would be sitting on the beach during sunrise after a mountain night hike.',
    false);

  private _tom_plews = new TeamMember(  // "Director, CLS Data, CLS Property Insight, CLS Risk Solutions"
    0, 'Tom', 'Plews', 'Tom.Plews@clsl.co.uk', 'Director, Innovation, CLS DATA, CLS PI, CLS GS',
    '+44(0) 1732 753 910', '../../../assets/members/tom-p.png',
    'Tom is the inspiration behind the creation of CLS Data, its products and initiatives and is the modest, unassuming Master of the Greater Interconnectivity of All Things...Tom works extensively with data in the search and insurance sectors. An expert in business process, negotiation, operations management, enterprise software and e-commerce, Tom specialises in turning data into information and products for effective integration with business process within the search, insurance and lending sectors.',
    false);

  private _penny_andrews = new TeamMember(//  BSc, MEng, DipNDEA, MRICS, CEnv
    0, 'Penny', 'Andrews', 'Penny.Andrews@clsrs.co.uk', 'Lead Environmental Underwriter, CLS Risk Solutions UK',
    this.cls_rs_number, '../../../assets/members/penny.png',
    'Penny, a property professional with many years’ experience as a Chartered Environmental Surveyor and a Chartered Environmentalist joined CLS in September 2016 as our environmental risk specialist. Having previously worked extensively in due diligence for property investment, management, development and regulation, her expertise is principally in environmental risk. However, Penny also has professional experience in waste management, civil engineering, quality management and planning applications as well as developing and auditing methodologies across the environmental search industry. Since joining CLS she has applied her specialist knowledge of the environmental risks and liabilities of property ownership, management and development to the world of insurance, successfully growing a substantial product and client base.',
    false);

  //
  private _cristina_sinchetriu = new TeamMember(
    0, 'Cristina', 'Sînchetriu', 'Cristina.Sinchetriu@clsrs.eu', 'Lead Underwriter, Public Law, CLS Risk Solutions EU',
    this.cls_rs_eu_number, '../../../assets/members/Cristina.png',
    'Cristina joined CLS in 2014 as a placement year intern assisting on general underwriting matters across various territories. After University, Cristina re-joined the CLS Underwriting team, underwriting bespoke Legal Indemnity (incl. Rights to Light) matters and is now primarily underwriting Judicial Review (Planning) risks from mainland Europe. Her focus is predominantly France and Germany. Alongside her Underwriter Director, her focus has been on creating risk tailored management strategies that facilitate the delivery of distressed projects(renewables), irrespective of any complications resulting from the materialisation of a planning flaw.  Outside CLS, Cristina is a Board member sitting on various committees aimed at organising and delivering a selection of events championing curiosity, personal and professional growth. TEDx was one of the most impactful and challenging projects she has organised so far.',
    false);

  //
  private _neil_wood = new TeamMember(
    0, 'Neil', 'Wood', 'Neil.Wood@clsl.co.uk', 'Business Development Manager, CLS Property Insight',
    '+44(0) 7903 113 760', '../../../assets/members/neil.png',
    'Neil is a critical part of our reseller network, ensuring our products and services are available to legal professionals across the UK. Neil has a unique market insight through working with key players in the industry and is focussed on helping FCI ensure products and services are of the highest standard.',
    false);

  private _justin_fortmann = new TeamMember(
    0, 'Justin', 'Fortmann', 'Justin.Fortmann@clsl.co.uk', 'Information Systems Manager, CLS Group Services',
    this.cls_gs_phone, '../../../assets/members/justin.png',
    'Justin is an Information Systems and Security Manager, with over a decade of IT systems and software development experience and several years software development management experience. Justin has served at CLS in various IT technical and managerial roles over the past eight years. Justin is currently responsible for IT infrastructure, information security and data management at CLS, as well as R&D in the Data team, and overseeing the IT support team.',
    false, 'ITSystems@clsl.co.uk');

  private _emily_coles = new TeamMember(
    0, 'Emily', 'Coles', 'Marketing@clsl.co.uk', 'Senior Marketing Manager, CLS Group Services',
    this.cls_gs_phone, '../../../assets/members/emily-coles.png',
    'Emily oversees marketing and event activity across the CLS Group in line with the business strategy, including; brand development, integrated campaigns across digital, email and offline, client and industry events, website development and SEO strategy, digital advertising, content marketing, PR, product design and marketing collateral.',
    false, 'Marketing@clsl.co.uk');


  //
  private _roy_partington = new TeamMember(
    0, 'Roy', 'Partington', 'Roy.Partington@clspropertyinsight.co.uk', 'Director, Underwriting, CLS Property Insight',
    this.cls_gs_phone, '../../../assets/members/roy.png',
    'Roy has extensive experience in the insurance industry and worked for a composite insurer and two Lloyd’s syndicates before setting up his own underwriting agency which merged with CLS in 2016. He has been involved in conveyancing-related insurances and lender insurance products for over 25 years and has been involved in designing and underwriting a variety of innovative products in that time. Roy was a Director of CLS Risk Solutions Limited before recently taking up the role of Underwriting Director of CLS Property Insight Limited. Outside of work Roy enjoys DIY, reading, and watching sport.',
    false);

  private _michael_grimwood = new TeamMember(
    0, 'Michael', 'Grimwood', 'Michael.Grimwood@clsrs.co.uk', 'Business Development Manager',
    this.cls_rs_number, '../../../assets/members/MichealGrimwood.png',
    'Michael has worked within the real estate insurance market for the last 10 years with some of the big composite carriers (Zurich, AXA, LV). Real estate has always been a professional passion and CLS has given him a new inspiration for learning again.	Michael started his career as a broker and wanted to understand the mechanics behind the price and pursued underwriting, this quickly became a specialism in property investors portfolio’s. Michael is a huge car enthusiast, anything with an engine will get his attention.Keeping fit seems to be rising up the agenda the older he gets, although marathons are not on his agenda yet.',
    false);

  private _pi_team = new TeamMember(
    0, 'Legal Indemnity Underwriting', 'and Customer Support Team', 'info@clspropertyinsight.co.uk', 'Your Dedicated Experts',
    '+44 (0)1732 753 910', '../../../assets/members/clientservices-team.png',
    'The Client Service team are experts when dealing with queries. Their primary objective is to use their expertise and product knowledge to ensure all of our clients are provided with fast and efficient transactional solutions. They are able to assist with any online insurance queries and search related requests.', false);

  private _ellie_steele = new TeamMember(
    0, 'Ellie', 'Steele', 'Ellie.Steele@clspropertyinsight.co.uk', 'Underwriter/Team Leader, CLS Property Insight',
    '+44(0)1732 753 932', '../../../assets/members/Ellie@2x.png',
    'Having worked at CLS since 2014, Ellie leads the Legal Indemnity team in the Kent office, along with Roy Goodman, to deal with Residential and Commercial continued use and development enquiries. Ellie started as a Client Services Administrator, dealing directly with clients to assist website enquiries and has progressed through the firm to become an Underwriter. Combining her knowledge of the extensive suite of products, and dedication to providing great customer service to clients, Ellie is a key contact for Legal Indemnity enquiries. In her spare time, Ellie enjoys booking spontaneous holidays with friends, trying new cocktails and adding to her ever-expanding wardrobe.',
    false);

  private _roy_goodman = new TeamMember(
    0, 'Roy', 'Goodman', 'roy.goodman@clspropertyinsight.co.uk', 'Lead Underwriter',
    '+44(0)1732 756 537', '../../../assets/members/roy-goodman.png',
    'Having been involved in the Legal Indemnities market for nearly 20 years, Roy brings a wealth of knowledge and experience that he will bring to our CLS PI suite of insurance and searches products. Roy now joins the growing CLS Property Insight team as Lead Underwriter and will lead the Legal Indemnity team in the Kent office, along with Ellie Steele, to deal with Residential and Commercial continued use and development enquiries. In Roy’s spare time, he loves to play cricket, go fishing and explore the local countryside with his wife and dog, especially if it finishes with a pint of Kentish Ale.',
    false);

  private _lianne_goddard = new TeamMember(
    0, 'Lianne', 'Goddard', 'lianne.goddard@clspropertyinsight.co.uk', 'Managing Director, CLS Property Insight',
    '+44(0)1732 753 910', '../../../assets/members/lianne-goddard.png',
    'Lianne is no stranger to the property market, following a successful career to date working with 4 Of The 5 Magic Circle Law Firms and 9 of the Top 10 Largest Financial Institutions, she has now started a new adventure at CLS Property Insight as Managing Director. Bringing a wealth of sales, management and industry experience, Lianne is excited to further innovate and lead the next exciting stage of CLS PI’s growth. Fun fact about Lianne: Not only did she win a Harley Davidson on the Vegas slots, but she also got to eat breakfast with the legend Muhammad Ali and cocktails with Ray Charles – what an experience!',
    false);

  private _steve_johnson = new TeamMember(
    0, 'Steve', 'Johnson', 'steve.johnson@clspropertyinsight.co.uk', 'National Key Account Manager',
    '+44(0)1732 753 910', '../../../assets/members/steve-johnson.png',
    'Steve Johnson joins the growing CLS Property Insight family as National Key Account Manager. Initially starting his career at Ordnance Survey then progressing to Landmark, he now embarks on a new journey with CLS, bringing with him a wealth of knowledge, especially within the environmental and searches sector. Outside of work, Steve enjoys off road cycling, running off road, obsessing about Formula 1 and practising sign-language with his kids. ',
    false);

  private _katy_stevens = new TeamMember(
    0, 'Katy', 'Stevens', 'Katy.Stevens@clspropertyinsight.co.uk', 'Underwriter/Client Services Manager, CLS Property Insight',
    '+44(0)1732 753 930', '../../../assets/members/KatyS@2x.png',
    'Having worked at CLS since 2013, Katy now manages the Customer Support Team in the Kent office, dealing with daily requests and enquiries from clients and working closely with the Underwriting team. Katy has climbed the ladder within CLS initially being recruited as a Client Services Administrator, to an Underwriter and has more recently been promoted as the Client Services Manager. Katy utilises her knowledge and skills to providing excellent customer service to all CLS’ clients and assisting with making the customer journey a remarkable  experience. Katy is a key contact for any enquiries from general enquiries, to search enquiries and even online insurance enquiries. In her spare time, Katy enjoys going on adventures with her family, being spontaneous and living life to the fullest.',
    false);

  private _liam_gilhooly = new TeamMember(
    0, 'Liam', 'Gilhooly', 'Liam.Gilhooly@clsrs.co.uk', 'Latent Defects Underwriter',
    this.cls_rs_number, '../../../assets/members/Liam-G.png',
    'Liam joined CLS in July 2019, having worked in home warranty and commercial latent defects since August 2004 for NHBC and then Aviva.  His current focus is on growing the team to work with a handful of selected partners. Outside of the office, Liam is a big fan of ze scuba, rock music, extreme napping and telling incredible dull anecdotes!',
    false);

  private _chris_gwynn = new TeamMember(
    0, 'Chris', 'Gwynn', 'Chris.Gwynn@clsrs.co.uk', 'Lead Underwriter',
    this.cls_rs_number, '../../../assets/members/ChrisG.png',
    'Chris leads the UK Public Law team at CLS RS and specialises in delivering tailored insurance solutions for risks associated with challenges to administrative or public decisions. Chris’ current focuses in this area have been live judicial review risks and challenges to the public procurement process. Outside of the office, Chris enjoys playing bass guitar, going to gigs, reading, and cycling.',
    false);

  private _development = new TeamMember(
    0, 'Development', 'Team', 'Development@clsl.co.uk', '', this.cls_gs_phone, '../../../assets/members/development.png', '', false);

  // d-risk
  private _geoff_offen = new TeamMember(
    0, 'Geoff', 'Offen', 'Geoff.Offen@d-riskgroup.com', 'Chairman',
    '+44(0) 7809 337 431', '../../../assets/CLS-DRisk/Geoff@2x.png',
    'Geoff is a pioneer of mining and environmental risk data; setting the national standards in the public and private sector in the UK and overseas. Geoff led the team that built the national coal mining database and the coal mining reports system, setting the benchmark for the coal mining reports used today by the Coal Authority and its licensees. Geoff led the development of environmental due diligence reports for property professionals in the UK and The Netherlands and was instrumental in developing software based real estate land information and mortgage risk appraisals for the German lending banks.',
    false);

  private _andrew_pullman = new TeamMember(
    0, 'Andrew', 'Pullman', 'Andrew.Pullman@d-riskgroup.com', 'Managing Director',
    '+44(0) 7852 972 703', '../../../assets/CLS-DRisk/Andrew@2x.png',
    'Andrew has a unique combination of expertise and knowledge at the top level in the commercial property and financial sectors. With a strong background in civil engineering Andrew has a long track record advising on mitigating environmental risk and unlocking potential in commercial land transactions and development. His experience includes managing large teams of engineers and scientists on major contracts for the remediation of brownfield land, dealing with all aspects, from conceptualisation and costings through to contracting and final validation.',
    false);

  private _aaron_jones = new TeamMember(
    0, 'Aaron', 'Jones', 'Aaron.Jones@d-riskgroup.com', 'Flood Risk & Climate Change',
    '+44(0) 7950 904 643', '../../../assets/CLS-DRisk/Aaron@2x.png',
    'Aaron’s experience within the flood sector enables unrivalled turnkey solutions for commercial risk exposure. Aaron has a flood modelling background and has worked on the design and installation of flood defence measures on some of the country’s most critical infrastructure assets. With his understanding of flood risk impact across a range of commercial sectors, including investment and insurance, Aaron is able to provide workable solutions and advice when dealing with the future challenges faced by climate change.',
    false);

  private _oliver_baldock = new TeamMember(
    0, 'Oliver', 'Baldock', 'Oliver.Baldock@d-riskgroup.com', 'Product Development & Innovation',
    '+44(0) 7507 861 452', '../../../assets/CLS-DRisk/Olly@2x.png',
    'Oliver is the go to expert on practical and innovative products, systems and solutions for all clients in the commercial real estate, development and financial markets. Oliver combines his professional expertise as a geoscientist and real practical experience in environmental consultancy and land remediation, with a deep understanding of spatial data, geographical information systems and workflow processing.',
    false);


  // private _ = new TeamMember(
  //  0, "", "", "", "",
  //  "01234 567 890", "linkedin", "../../../assets/members/.png",
  //  "",
  //  false);

  constructor() { }

  public get_tm_home(): TeamMember[] {

    let members: TeamMember[] = [];

    members.push(
      this._roy_partington,
      this._lianne_goddard,
      this._mandy_stephens,
      this._tom_plews
    );

    members.forEach((member: TeamMember, i: number) => {
      member.index = i;
    });

    this._lianne_goddard.isActive = true;

    return members;
  }

  public get_tm_home_serviceWheel() {
    let members: TeamMember[] = [];

    this._pi_team.fullname = 'Client Services';
    members.push(
      this._pi_team, // pi
      this._mandy_stephens, // gs
      this._stacey_coppack, // cc
      this._neil_wood, // fci
      this._tom_plews, // data

      // gs
      this._stacey_coppack, // [6]
      this._emily_coles, // [8]
      this._justin_fortmann, // [9]
      this._development, // [10]

      // rs
      this._penny_andrews, // [12]
      this._chris_gwynn, // [13]
      this._michael_turland, // [14]
      this._matt_chappell, // [15]
      this._vicky_sweeney, // [16]

      this._andrew_pullman // [17]
    );

    return members;
  }

  public get_tm_risksolutions() {
    let members: TeamMember[] = [];


    members.push(
      this._penny_andrews,
      this._michael_turland,
      this._vicky_sweeney,
      this._michael_grimwood,
      this._phil_jarvis,
      this._chris_gwynn,
      this._liam_gilhooly

    );

    members.forEach((member: TeamMember, i: number) => {
      member.index = i;
    });

    return members;
  }

  public get_tm_propertyinsight() {
    let members: TeamMember[] = [];

    members.push(
      this._neil_wood,
      this._lianne_goddard,
      this._chantelle_wren,

      this._katy_stevens,
      this._ellie_steele,
      this._roy_goodman,
      this._steve_johnson
    );

    members.forEach((member: TeamMember, i: number) => {
      member.index = i;
    });

    this._lianne_goddard.isActive = true;

    return members;
  }

  public get_tm_europe() {
    let members: TeamMember[] = [];


    members.push(
      this._william_brooks,
      this._cristina_sinchetriu
    );

    members.forEach((member: TeamMember, i: number) => {
      member.index = i;
    });

    this._william_brooks.isActive = true;

    return members;
  }

  public get_tm_drisk() {
    let members: TeamMember[] = [];


    let _geoff: TeamMember = Object.assign({}, this._geoff_offen);
    let _andrew: TeamMember = Object.assign({}, this._andrew_pullman);
    let _oliver = Object.assign({}, this._oliver_baldock);
    let _aaron = Object.assign({}, this._aaron_jones);

    members.push(
      _geoff, _aaron,
      this._andrew_pullman,
      this._oliver_baldock,
      this._geoff_offen,
      this._aaron_jones,
      _andrew, _oliver
    );

    members.forEach((member: TeamMember, i: number) => {
      member.index = i;
    });

    this._geoff_offen.isActive = true;

    return members;

  }
}
